import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FailureDescription } from "../../../go/model/form.model";
import { DateISO } from "../../../../model/general.model";
import { DATE_TIME_FORMAT, getLocalDate } from "../../../../utils/date.utils";

@Component({
  selector: 'failure-item',
  templateUrl: './failure-item.component.html',
  styleUrls: ['./failure-item.component.scss']
})
export class FailureItemComponent {
  @Input() index: number;
  @Input() last: boolean;
  @Input() item: FailureDescription;
  @Input() showDate = false;
  @Output() editFailureEvent = new EventEmitter<number>();

  getItemCodes(item: FailureDescription) {
    return item.failureCodes.map(x => x.code).join(', ');
  }

  editFailure() {
    this.editFailureEvent.emit(this.index);
  }

  formatDate(date: DateISO): string {
    return getLocalDate(date, DATE_TIME_FORMAT);
  }
}
